const VehicleDetails = {
  validHeader: {
    'Vehicle Number': 'vehicle_number',
    'Depot Reference Id': 'depot_reference_id',
    'Transporter Reference Id': 'transporter_reference_id',
    'Availability(true/false)': 'is_vehicle_available',
  },
};

module.exports = { VehicleDetails };
